export default __webpack_public_path__ + "static/media/officeIcon-light.36af6ba6.svg";